<template>
  <DetailTemplate
    :customClass="'property-detail property-property-detail detail-page'"
    v-if="getPermission('property:view')"
  >
    <template v-slot:sidebar-detail>
      <v-card class="h-100" elevation="0">
        <div class="d-flex">
          <v-chip
            label
            color="chip-custom-blue"
            outlined
            class="text-white p-3 mt-2"
            v-if="addonArr.barcode"
            style="font-size: 21px !important; font-weight: 700"
          >
            {{ addonArr.barcode }}
          </v-chip>
          <v-chip
            class="ma-2 custom-status font-weight-500 text-uppercase custom-grey-border"
            text-color="white"
            color="green"
            v-if="addonArr.status === '1'"
            label
          >
            Active
          </v-chip>
          <v-chip
            class="ma-2 custom-status font-weight-500 text-uppercase custom-grey-border"
            text-color="white"
            color="red"
            v-else
            label
          >
            In-Active
          </v-chip>
        </div>
        <v-card
          flat
          class="custom-grey-border remove-border-radius mb-4 h-100 mt-3"
        >
          <v-card-title class="headline grey lighten-4 py-1">
            <span
              class="font-weight-700 custom-headline color-custom-blue font-size-16 text-uppercase"
            >
              Add On Information</span
            >
          </v-card-title>
          <table class="width-100">
            <tr>
              <th
                valign="middle"
                class="font-size-18 font-weight-500 text-capitalize pb-0"
                width="150px"
              >
                Add On #
              </th>

              <td class="font-size-18 text-capitalize">
                <v-chip
                  class="font-weight-600 custom-barcode pb-0"
                  color="chip-custom-blue"
                  outlined
                  label
                >
                  {{ addonArr.barcode }}
                </v-chip>
              </td>
            </tr>
            <tr>
              <th
                valign="middle"
                class="font-size-18 font-weight-500 text-capitalize"
                width="150px"
              >
                Name
              </th>
              <td valign="middle" class="font-size-18 text-capitalize">
                <div v-if="addonArr?.name">
                  {{ addonArr?.name }}
                </div>
                <em v-else class="text-muted"> no name </em>
              </td>
            </tr>
            <!-- <tr> -->
              <!-- <th
                valign="middle"
                class="font-size-18 font-weight-500 text-capitalize pt-0"
              >
                Tax
              </th> -->
              <!-- <td valign="middle" class="font-size-18 text-capitalize pt-1">
                <template v-if="addonArr?.tax">
                  {{ addonArr?.tax }}
                </template>
                <em v-else class="text-muted"> no tax</em>
              </td> -->
            <!-- </tr> -->
            <!-- <tr>
              <th
                valign="middle"
                class="font-size-18 font-weight-500 text-capitalize pt-0"
              >
                Duration
              </th>
              <td valign="middle" class="font-size-18 text-capitalize pt-1">
                <template v-if="addonArr?.duration">
                  {{ addonArr?.duration }} {{ addonArr?.duration_type }}
                </template>
                <em v-else class="text-muted"> no duration</em>
              </td>
            </tr> -->
            <tr>
              <th
                valign="middle"
                class="font-size-18 font-weight-500 text-capitalize pt-0"
              >
                Description
              </th>
              <td valign="middle" class="font-size-18 text-capitalize pt-1">
                <template v-if="addonArr?.description">
                  {{ addonArr?.description }}
                </template>
                <em v-else class="text-muted"> no description</em>
              </td>
            </tr>
            <!-- <tr>
              <th
                class="font-size-18 font-weight-500 text-capitalize pt-1"
                width="150px"
              >
                Quantity
              </th>
              <td class="font-size-18 text-capitalize pt-1">
                <template v-if="addonArr?.quantity">
                  {{ addonArr?.quantity }}
                </template>
                <em v-else class="text-muted"> no quantity</em>
              </td>
            </tr> -->
            <tr>
              <th
                class="font-size-18 font-weight-500 text-capitalize pt-1"
                width="150px"
              >
                Price
              </th>
              <td class="font-size-18 text-capitalize pt-1">
                <template v-if="addonArr?.price">
                  {{ addonArr?.price }}
                </template>
                <em v-else class="text-muted"> no price</em>
              </td>
            </tr>
            <tr>
              <th class="font-size-18 font-weight-500 text-capitalize pt-1" width="150px">
                SQFT Required
              </th>
              <td class="font-size-18 text-capitalize pt-1">
                <v-chip :label="true" :color="addonArr?.sqft_required == '1' ? 'green' : 'red'" class="text-white" small>
                  {{ addonArr?.sqft_required == 1 ? 'Yes' : 'No' }}
                </v-chip>


              </td>
            </tr>

            <!--  <tr>
              <th class="font-size-18 font-weight-500 text-capitalize pt-1" width="150px">
                Add Extra Price
              </th>
              <td class="font-size-18 text-capitalize pt-1">
                <v-chip :label="true" :color="addonArr?.add_extra_price === '1' ? 'green' : 'red'" class="text-white"
                  small>
                  {{ addonArr?.add_extra_price === 1 ? 'Yes' : 'No' }}
                </v-chip>

              </td>
            </tr> -->
          </table>
        </v-card>
      </v-card>
    </template>
    <template v-slot:header-title>
      <div v-if="pageLoading">
        <v-skeleton-loader
          class="custom-skeleton"
          width="400"
          height="28"
          type="text"
        >
        </v-skeleton-loader>
      </div>

      <div class="d-flex" v-else>
        <h1 class="form-title custom-nowrap-ellipsis text-capitalize mr-2 mt-3">
          {{ getPageTitle }}
        </h1>
      </div>
    </template>
    <template v-slot:header-action>
      <v-skeleton-loader
        class="custom-skeleton d-inline-block mr-2"
        v-if="pageLoading"
        type="button"
        height="28"
      >
      </v-skeleton-loader>
      <template v-if="getPermission('property:update')">
        <v-skeleton-loader
          class="custom-skeleton d-inline-block mr-2"
          v-if="pageLoading"
          type="button"
          height="28"
        >
        </v-skeleton-loader>
        <v-btn
          depressed
          v-else
          class="mx-2 custom-bold-button white--text"
          color="cyan"
          v-on:click="ViewCreateAddon = true"
        >
          <v-icon small left>mdi-pencil</v-icon>
          Edit
        </v-btn>
      </template>

      <v-menu
        transition="slide-y-transition"
        bottom
        offset-y
        :nudge-left="20"
        content-class="custom-menu-list"
      >
        <template v-slot:activator="{ on, attrs }">
          <v-btn
            :disabled="!formValid || formLoading || pageLoading"
            :loading="formLoading"
            class="mx-2 custom-bold-button white--text"
            color="cyan"
            v-bind="attrs"
            v-on="on"
          >
            More... <v-icon right>mdi-chevron-down</v-icon>
          </v-btn>
        </template>
        <v-list>
          <template v-for="(more, index) in moreActions">
            <v-list-item
              link
              v-on:click="updateMoreAction(more.action)"
              :key="index"
              :disabled="more.disabled"
            >
              <v-list-item-icon class="margin-auto-zero mr-3 my-2">
                <v-icon class="icon-default-blue">{{ more.icon }}</v-icon>
              </v-list-item-icon>
              <v-list-item-title class="font-weight-400 font-size-12">{{
                more.title
              }}</v-list-item-title>
            </v-list-item>
          </template>
        </v-list>
      </v-menu>
      <v-menu
        transition="slide-y-transition"
        bottom
        offset-y
        :nudge-left="20"
        content-class="custom-menu-list"
      >
        <template v-slot:activator="{ on, attrs }">
          <!-- <v-btn :disabled="!formValid || formLoading || pageLoading" :loading="formLoading"
            class="mx-2 custom-bold-button white--text" color="cyan" v-bind="attrs" v-on="on">
            More... <v-icon right>mdi-chevron-down</v-icon>
          </v-btn> -->
        </template>
        <v-list>
          <template v-for="(more, index) in moreActions">
            <v-list-item
              link
              v-on:click="updateMoreAction(more.action)"
              :key="index"
              :disabled="more.disabled"
            >
              <v-list-item-icon class="margin-auto-zero mr-3 my-2">
                <v-icon class="icon-default-blue">{{ more.icon }}</v-icon>
              </v-list-item-icon>
              <v-list-item-title class="font-weight-400 font-size-12">{{
                more.title
              }}</v-list-item-title>
            </v-list-item>
          </template>
        </v-list>
      </v-menu>
      <v-btn
        depressed
        class="mx-2 custom-grey-border custom-bold-button"
        v-on:click="goBack"
      >
        <v-icon small left>mdi-keyboard-backspace</v-icon>
        Back
      </v-btn>
    </template>
    <template v-slot:body>
      <v-tabs
        v-model="addonTab"
        background-color="transparent"
        color="cyan"
        class="custom-tab-transparent"
      >
        <template v-for="(tab, index) in tabs">
          <v-tab
            class="font-size-16 font-weight-600 px-8"
            :key="index"
            :href="'#' + tab.key"
            :disabled="tab.disabled"
          >
            <span class="svg-icon svg-icon-lg mr-4 svg-v-list-icon">
              <!--begin::Svg Icon-->
              <inline-svg
                :src="$assetURL('media/custom-svg/' + tab.key + '.svg')"
              />
              <!-- <v-icon v-if="tab.icon" class="mr-2" size="20">
                <span class="svg-icon svg-icon-lg mr-2 svg-v-list-icon">
                  <inline-svg :src="$assetURL('media/custom-svg/attachment.svg')" />
                </span> </v-icon> -->
              <!--end::Svg Icon-->
            </span>
            {{ tab.title }}
          </v-tab>
        </template>
      </v-tabs>
      <perfect-scrollbar
        :options="{ suppressScrollX: true }"
        class="scroll newscroll"
        style="height: calc(100vh - 150px)"
      >
        <v-tabs-items v-model="addonTab">
          <v-tab-item
            v-if="getPermission('property:view')"
            :value="'attachment'"
          >
            <AdditionalDocuments
              :type-id="addonArr.id"
              class="mx-4"
              type-text="Add On"
              :type="33"
              :extensive="false"
            >
            </AdditionalDocuments>
          </v-tab-item>
          <!-- <v-tab-item v-if="getPermission('history:view')" :value="'history'">
            <InternalHistoryDetail type="payroll" :type_id="addonArr?.id"></InternalHistoryDetail>
          </v-tab-item> -->
        </v-tabs-items>
      </perfect-scrollbar>
      <template v-if="TransformerDialog">
        <TransformerDialog
          :entity="Number(1)"
          :TransformerDialog="TransformerDialog"
          :customer="addonArr?.customer?.id"
          v-on:closeDialog="TransformerDialog = false"
          @closeTransformer="closeTransformer"
          v-on:selectTransformer="selectTransformer"
          v-on:resetAll="TransformerDialog = false"
        ></TransformerDialog>
      </template>
      <template v-if="ViewCreateAddon">
        <CreateAddons
          :entity="Number(entity)"
          v-on:closeDialog="ViewCreateAddon = false"
          :batch_id="addonArr?.id"
          :ViewCreateAddon="ViewCreateAddon"
          @closeDialog="closeDialogBatch"
          @afterSubmit="afterSubmit"
        >
        </CreateAddons>
      </template>
    </template>
  </DetailTemplate>
</template>

<script>
import CommonMixin from "@/core/plugins/common-mixin";
import ValidationMixin from "@/core/plugins/validation-mixin";
import { SET_BREADCRUMB } from "@/core/services/store/breadcrumbs.module";
// import Barcode from "@/view/pages/partials/Barcode.vue";
import DetailTemplate from "@/view/pages/partials/Detail-Template.vue";
import { GET, PATCH } from "@/core/services/store/request.module";
import moment from "moment";
import AdditionalDocuments from "@/view/pages/engineer/Additional-Documents";
import CreateAddons from "@/view/pages/add-ons/Create-Addons.vue";

export default {
  mixins: [CommonMixin, ValidationMixin],
  name: "property-detail",
  title: "Site Location",
  data() {
    return {
      addonTab: "oilsamples",
      cleaner: null,
      addon: null,
      TransformerDialog: false,
      ViewCreateAddon: false,
      customer: 0,
      pageLoading: true,
      entity: true,
      deleteDialog: false,
      addonArr: {},
      history: [],
      moreActions: [],

      tabs: [
        {
          title: "Attachments",
          icon: "mdi-ticket",
          key: "attachment",
          disabled: false,
        },
      ],
      createTransactions: [
        {
          title: "Visit",
          action: "job",
        },
      ],
    };
  },
  components: {
    // Barcode,
    DetailTemplate,
    AdditionalDocuments,
    CreateAddons,
  },
  methods: {
    formatDateStartTime() {
      return moment().format("hh:mm A");
    },
    closeTransformer() {
      this.TransformerDialog = false;
    },
    closeDialogBatch() {
      this.ViewCreateAddon = false;
    },
    afterSubmit() {
      const _this = this;
      this.getAddon()
        .then(() => {
          _this.getAddon().then((response) => {
            _this.addonArr = response;
            _this.moreActions = response.more_actions;
          });
          _this.pageLoading = false;
        })
        .catch((error) => {
          _this.logError(error);
        });
    },
    updateMoreAction(action) {
      const _this = this;
      this.statusValue = action;
      switch (action) {
        case "mark_as_active":
          _this.patchAddon(action);
          break;
        case "mark_as_in_active":
          _this.patchAddon(action);
          break;
      }
    },
    patchAddon(action = "") {
      const _this = this;
      // _this.statusVal = status;
      _this.pageLoading = true;
      _this.$store
        .dispatch(PATCH, {
          url: "addon/status",
          data: {
            addon: [_this.addon],
            action,
            remark: null,
          },
        })
        .then(() => {
          _this.getAddon().then((response) => {
            _this.addonArr = response;
            _this.moreActions = response.more_actions;
          });
          _this.pageLoading = false;
        })
        .catch((error) => {
          _this.logError(error);
        });
    },
    editAddon() {
      this.$router.push(
        this.getDefaultRoute("addon.update", {
          params: { cleaner: this.addonArr?.id },
          query: { transformer: this.addonArr?.transformer?.id },
        })
      );
    },
    getAddon() {
      const _this = this;
      return new Promise((resolve, reject) => {
        try {
          _this.$store
            .dispatch(GET, { url: "addon/" + _this.addon })
            .then((response) => {
              resolve(response.data);
            })
            .catch((error) => {
              reject(error);
            });
        } catch (error) {
          reject(error);
        }
      });
    },
  },
  mounted() {
    const _this = this;
    _this
      .getAddon()
      .then((response) => {
        _this.addonArr = response;
        _this.moreActions = response.more_actions;
        _this.$store.dispatch(SET_BREADCRUMB, [
          { title: "Add-On", route: "addon" },
          { title: "Detail" },
          { title: response.barcode },
        ]);
      })
      .catch((error) => {
        _this.logError(error);
        _this.$router.go(-1);
      })
      .finally(() => {
        _this.pageLoading = false;
      });
  },
  created() {
    const _this = this;
    _this.addon = _this.$route.params.id;
    if (!_this.addon || _this.addon <= 0) {
      _this.$router.go(-1);
    }

    if (_this.$route.query && _this.$route.query.tab) {
      _this.addonTab = _this.$route.query.tab;
    }
  },
  computed: {
    getPageTitle() {
      let result = [];
      if (this.addonArr && this.addonArr.customer) {
        result.push(this.addonArr.customer.display_name);
      }
      return result.join(" • ");
    },

    getBarcode() {
      return this.lodash.isEmpty(this.addonArr) === false
        ? this.addonArr.barcode
        : false;
    },
  },
};
</script>
